<template>
  <box-contents 
  :itemSource.sync="activeBoxItems" 
  :activeBox="activeBox"
  :boxOrderIDMap="boxOrderIDMap"
  :savedInputs="savedInputs"
  :mergeMap="mergeMap"
  :mergePayload="mergePayload"
  :inventoryView="inventoryView"
  :singleMode="singleMode"
  @addItem="addItem"
  @onDelete="onDelete"
  ref="boxContents">
  </box-contents>
</template>

<script>
import BoxContents from "./box-contents"

export default {
  props: {
    itemSource: {
      type: Array
    },
    savedInputs: null,
    mergeMap: null,
    inventoryView: null,
    activeBox: null,
    boxOrderIDMap: null,
    singleMode: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BoxContents
  },
  data () {
    return {
      items: []
    }
  },
  watch: {
    itemSource: {
      immediate: true,
      handler (items) {
        this.items = items
      }
    },
    items (nv) {
      this.$emit('update:itemsSource', nv)
    }
  },
  computed: {
    mergePayload () {
      return {
        items: this.items,
        savedInputs: this.savedInputs,
        mergeMap: this.mergeMap
      }
    },
    activeBoxItems () {
      if (this.activeBox !== null) {
        return this.items.filter(item => item.box === this.activeBox)
      }
      return this.items
    }
  },
  methods: {
    addItem (item) {
      this.items.push(item)
    },
    onDelete (idArray) {
      var title =
        "Delete " +
        idArray.length +
        " item" +
        (idArray.length === 1 ? "" : "s") +
        "?";
      this.$root
        .$confirm(title, "Are you sure?", { color: "purple" })
        .then(confirm => {
          if (confirm) {
            for (var i = this.items.length - 1; i >= 0; --i) {
              if (idArray.includes(this.items[i].tempID)) {
                this.items.splice(i, 1);
              }
            }
            this.$refs.boxContents.onSuccessfullDelete()
          }
        });
    }
  }
}
</script>